/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { ToolVariation, ToolVariation$inboundSchema } from "./toolvariation.js";

export type ListVariationsResult = {
  variations: Array<ToolVariation>;
};

/** @internal */
export const ListVariationsResult$inboundSchema: z.ZodMiniType<
  ListVariationsResult,
  unknown
> = z.object({
  variations: z.array(ToolVariation$inboundSchema),
});

export function listVariationsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListVariationsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListVariationsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListVariationsResult' from JSON`,
  );
}
